import { render, staticRenderFns } from "./RepaletizajeForm2.vue?vue&type=template&id=f89e7e80&scoped=true&"
import script from "./RepaletizajeForm2.vue?vue&type=script&lang=js&"
export * from "./RepaletizajeForm2.vue?vue&type=script&lang=js&"
import style0 from "./RepaletizajeForm2.vue?vue&type=style&index=0&id=f89e7e80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89e7e80",
  null
  
)

export default component.exports